var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M14 12.556c0 3.259-4 3.259-4 0C10 10.482 12 9 12 9s2 1.482 2 3.556Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12m20 0c0-5.523-4.477-10-10-10m10 10h-2M2 12C2 6.477 6.477 2 12 2M2 12h2m8-10v2m7 1-1 1m1 13-1-1M5 19l1-1M5 5l1 1"
})));
export default SvgDashboard;